import React, { useContext, useState, useEffect, useCallback } from 'react'
import { Location } from '@reach/router'
import { navigate, graphql, useStaticQuery } from 'gatsby'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import LanguageContext from '../../contexts/languageContext'
import { changeUrlLanguage } from '../../utils/navigation'
import style from './style'
import styles from './styles.module.css'

const LanguageSwapper = () => {
  const { allMarkdownRemark } = useStaticQuery(query)
  const { lang, setLanguage } = useContext(LanguageContext)
  const { t } = useTranslation()
  const languages = allMarkdownRemark.distinct
  const [options, setOptions] = useState([])

  useEffect(() => getOptions(), [lang]) // eslint-disable-line react-hooks/exhaustive-deps

  const getOptions = () =>
    setOptions(
      languages.map(lang => ({
        value: lang,
        label: t(`languages.${lang}`),
      }))
    )

  const handleClick = useCallback(
    (language, location) => {
      const newPath = changeUrlLanguage(location.pathname, lang, language)
      const url = process.env.GATSBY_PATH_PREFIX ? newPath.replace(`/${process.env.GATSBY_PATH_PREFIX}`, '') : newPath

      setLanguage(language)
      navigate(url)
    },
    [lang, setLanguage]
  )

  if (languages.length <= 1) return null

  return (
    <Location>
      {({ location }) => (
        <div className={styles.container}>
          <span className={styles.label}>{t('general.language')}</span>
          <Select
            components={{
              IndicatorSeparator: () => null,
            }}
            data-testid="sample-code-select"
            isSearchable={false}
            menuPlacement="top"
            onChange={({ value }) => handleClick(value, location)}
            options={options}
            styles={style}
            value={{ label: t(`languages.${lang}`), value: lang }}
          />
        </div>
      )}
    </Location>
  )
}

const query = graphql`
  {
    allMarkdownRemark {
      distinct(field: fields___langKey)
    }
  }
`

export default LanguageSwapper
